export const getHeader = (headers, headerName) => {
  headerName = headerName.toLowerCase();
  return headers.get ? headers.get(headerName) : headers[headerName];
};
